module.exports = __webpack_public_path__ + "static/media/Link.e99e8015.svg";